import React from 'react';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  initials: 'CR',
  name: 'Cecilia R.',
  location: 'Mendoza',
  text: '"El Tomo 4 — El Manual del Iniciador — me salvó. Mi primera sintonización oficial fue perfecta. Los dos lloramos."'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  location: 'La Plata',
  text: '"El Tomo 5 de Reiki Business me dio todo lo que necesitaba para cobrar lo que vale mi trabajo sin bajar la voz."'
}, {
  initials: 'PA',
  name: 'Paula A.',
  location: 'Neuquén',
  text: '"El Diario de 30 Días fue lo que me mantuvo constante el primer mes. Sin eso creo que hubiera abandonado como siempre."'
}, {
  initials: 'JM',
  name: 'Julia M.',
  location: 'Rosario',
  text: '"Los Protocolos de Emergencia del Tomo 6 me dieron la confianza que me faltaba. Ahora trabajo con clientes en crisis sin miedo."'
}];
export function MoreTestimonialsSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-292">
      <div className="container mx-auto max-w-5xl" data-id="element-293">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-294">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-295">
            ❤️ MÁS PERSONAS QUE YA LO TIENEN
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-296">
          {TESTIMONIALS.map((t, idx) => <div key={idx} className="bg-[#111111] border border-white/5 rounded-2xl p-6 flex flex-col" data-id="element-297">
              <div className="flex items-center gap-3 mb-4" data-id="element-298">
                <div className="w-10 h-10 rounded-full bg-[#eab308]/20 border border-[#eab308]/30 flex items-center justify-center text-[#eab308] font-bold text-sm" data-id="element-299">
                  {t.initials}
                </div>
                <div data-id="element-300">
                  <div className="flex text-[#eab308] text-sm mb-0.5" data-id="element-301">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="text-white font-bold text-sm" data-id="element-302">
                    {t.name}{' '}
                    <span className="text-gray-500 font-normal" data-id="element-303">
                      — {t.location}
                    </span>
                  </p>
                </div>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-304">
                {t.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}